export const enum UserType {
    User = 'user',
    Admin = 'admin',
    SuperAdmin = 'superadmin',
}
